<div class="destinations-container-father">
  <div class="destinations-container" [class]="getRadius()" [style]="fullRadius && window.innerWidth < 550 ? 'height: calc(100vh - 90px);' : ''">
    <div class="destinations-content">
      <div class="destinations-title" [style]="marginTitle">
        <app-texts
          [texts]="title"
        />
      </div>
      <div class="circle-container" *ngIf="!loadingCircle" [style]="circlePosition">
        <app-circle
          [style]="circleStyle"
          [destinations]="destinationsArray.destinations"
          [disable]="prevBack || nextBack"
          [mode]="mode"
          (emitActive)="setback($event)"
          (emitObj)="emitObj($event)"
          (emitContinent)="setFilter($event)"
        />
      </div>
    </div>
    <div class="destinations-container-back"
         [style]="getStyle()"
         [style.background-image]="getBackground()"
    ></div>
    <div @prev *ngIf="prevBack" class="destinations-container-back destinations-container-back-prev"
         [style.background-image]="getBackgroundPrev()"
         [style]="getStylePrev()"
    ></div>
    <div @next *ngIf="nextBack" class="destinations-container-back destinations-container-back-next"
         [style.background-image]="getBackgroundNext()"
         [style]="getStyleNext()"
    ></div>
  </div>
</div>

